export const LOGIN_FORM = "LOGIN_FORM";
export const SIGNUP_FORM = "SIGNUP_FORM";
export const SHUTTERB_LOGIN = "SHUTTERB_LOGIN";
export const SHUTTERB_SIGNUP = "SHUTTERB_SIGNUP"; //IS PENDING
export const FORGOT_PASSWORD_FORM = "FORGOT_PASSWORD_FORM";
export const ACCOUNT_SELECTION = "ACCOUNT_SELECTION";
